module.exports = __webpack_public_path__ + "static/liverecover-7fb483cf814d129f208455d9a8a2ce0c.png";